module.exports = __webpack_public_path__ + "img/notification_bg.455728ef.jpg";